import React, { useState, } from 'react';
import { parse as parseCsv } from 'papaparse';
import classnames from 'classnames';
import { Button, Input, } from 'reactstrap';
import { toast } from 'react-toastify';

import { readCsvFile } from '../util';

export default function ImportButton ({ onComplete = _ => _, label = 'インポート', processRows, disabled = false, successMessage = 'インポートしました', ...extraProps }) {
  const [isImporting, setIsImporting] = useState(false);

  const onSelectFiles = async ({ target, target: { files: [file] } }) => {
    if(!file) return;
    setIsImporting(true);
    try {
      const fileContent = await readCsvFile(file);
      const { data: _rows } = parseCsv(fileContent, { header: true });
      const rows = _rows.filter(_ => Object.values(_).some(_ => _));
      await processRows(rows);
      await onComplete(rows);
      toast.success(successMessage);
    } catch(e) {
      console.error(e);
      toast.error('インポート失敗しました');
    }
    setIsImporting(false);
    target.value = '';
  };

  return (
    <Button color="secondary" disabled={disabled || isImporting} {...extraProps}>
      <label className="m-0 cursor-pointer">
        <span className={classnames('fas mr-1', { 'fa-upload': !isImporting, 'fa-spin fa-spinner': isImporting})} />
        {label}
        {
          !disabled && (
            <Input type="file" className="d-none" onChange={onSelectFiles} accept=".csv" />
          )
        }
      </label>
    </Button>
  );
};
